import { SignupForm } from "@/components/auth/signup-form.tsx";
import { m } from "@/paraglide/messages.js";
import { EMAIL_TOKEN_REGEX } from "@/utils/validation.ts";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { pageTitle } from "@/utils/page-title.ts";

// Setup token validation - should be base64 encoded string
const signupRouteSchema = z.object({
	email: z.email(),
	token: z.string().regex(EMAIL_TOKEN_REGEX),
});

export const Route = createFileRoute("/auth/signup")({
	component: RegisterComponent,
	validateSearch: signupRouteSchema,
	beforeLoad: ({ search }) => {
		const result = signupRouteSchema.safeParse(search);
		if (!result.success) {
			throw redirect({
				to: "/auth/start-signup",
				replace: true,
			});
		}
	},
	head: () => ({
		meta: [{ title: pageTitle(m.auth_create_organization()) }],
	}),
});

function RegisterComponent() {
	return <SignupForm />;
}
